import axios from "axios";
import Holidays from "date-holidays";

export const monthNames = ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"]

export default class DateHelpers {
  private static regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:[+-](?:\d{2}:\d{2})?)?$/

  static isIsoDateString(value: any): boolean {
    if (value && value instanceof Date)
      return true
    return value && typeof value === "string" && this.regex.test(value);
  }

  /**
   * Return name of month, using js month idx that starts at 0
   */
  static getMonthFromId(monthId: number): string {
    return monthNames[monthId]
  }

  static handleDates(body: any) {
    if (body === null || body === undefined || typeof body !== "object")
      return body;
    for (const key of Object.keys(body)) {
      const value = body[key];
      if (this.isIsoDateString(value)) {
        body[key] = new Date(value)
      } else if (typeof value === "object")
        this.handleDates(value);
    }
  }

  static registerAxiosDateParser() {
    axios.interceptors.response.use(originalResponse => {
      this.handleDates(originalResponse.data);
      return originalResponse;
    });
  }

  static getFirstPaymentDate() {
    const startDate = new Date()
    return new Date(startDate.getFullYear(), startDate.getMonth() + 1, 20)
  }

  static toDateString(date: Date | null) {
    if (!date)
      return ""
    let day = date.getDate()
    let month = date.getMonth() + 1
    return `${day < 10 ? "0" + day : day}.${month < 10 ? "0" + month : month}.${date.getFullYear()}`
  }

  static nextInvoiceDate() {
    const now = new Date()
    now.setMonth(now.getMonth() + 1)
    now.setDate(20)
    return now
  }

  static toDateTimeString(date: Date) {
    let day = date.getDate()
    let month = date.getMonth() + 1
    let hours = date.getHours().toString()
    if (date.getHours() < 10)
      hours = "0" + hours
    let minutes = date.getMinutes().toString()
    if (date.getMinutes() < 10)
      minutes = "0" + hours
    return `${day < 10 ? "0" + day : day}.${month < 10 ? "0" + month : month}.${date.getFullYear()} ${hours}:${minutes}`
  }

  static isHoliday(date: Date, hd: Holidays) {
    return hd.isHoliday(date) || date.getDay() === 0 || date.getDay() === 6
  }

  static getNextBusinessDay(date: Date): Date {
    const hd = new Holidays("NO")
    if (this.isHoliday(date, hd)) {
      while (this.isHoliday(date, hd)) {
        date.setDate(date.getDate() + 1)
      }
    }
    return date
  }
}